// src/components/alert/ReportNotAvailable.tsx

import { Alert, AlertTitle, Collapse, useTheme } from '@mui/material'

import { FolderId, FolderName } from '@/types/domain'

import { useFolderName } from '../../hooks'

type ReportNotAvailableProps = {
  id: FolderId
  condition: boolean
}

export const ReportNotAvailable = ({
  id,
  condition,
}: ReportNotAvailableProps) => {
  const theme = useTheme()
  const borderColor = theme.palette.error.main
  const border = `solid 1px ${borderColor}`

  const fName: FolderName = useFolderName(id)

  return (
    <Collapse in={condition} sx={{ mx: 1, my: 2 }}>
      <Alert severity={'error'} sx={{ border }}>
        <AlertTitle>Berichterstellung nicht verfügbar</AlertTitle>
        Das Gebäude <strong>{fName}</strong> enthält keine Verbrauchssensoren.
      </Alert>
    </Collapse>
  )
}
